import Head from 'next/head'
import React from 'react'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'

import { useGetPlaylists } from 'api/video-repository/useAPIPlaylists'
import { PlaylistCardShimmer } from 'app/VideoRepository/components/Preloader'
import Playlists from 'app/VideoRepository/Playlists'
import { EmptyState, EmptyStateAction } from 'components/EmptyState'
import { APP_LOGIN_STORAGE_KEY } from 'configs/auth'
import AndroidHandler from 'utils/androidHandler'
import { useLocalStorage } from 'utils/hooks/useLocalStorage'
import { REFERRER_KEY } from 'utils/hooks/useRouterHistory'

const VideoRepositoryPage = () => {
  const { data, isSuccess, isError, isLoading } = useGetPlaylists()
  const androidHandler = AndroidHandler()
  const [session] = useLocalStorage(APP_LOGIN_STORAGE_KEY, null)
  const [, , , getReferrerValue] = useLocalStorage(REFERRER_KEY, null)
  const referrer = getReferrerValue()

  return (
    <>
      <Head>
        <title>Video Inspirasi</title>
      </Head>
      <HeaderBar fixed variant="large">
        <HeaderBarLeftAction
          icon={<Icon as="i">arrow_back</Icon>}
          onClick={() => {
            if (androidHandler.enabled) {
              androidHandler.backToApp()
            } else {
              if (!!session && referrer === '') {
                window.location.href = `${process.env.NEXT_PUBLIC_BASE_URL}/home`
              } else {
                window.history.back()
              }
            }
          }}
        />
        <HeaderBarTitle>Video Inspirasi</HeaderBarTitle>
      </HeaderBar>
      <div
        className="bg-default"
        style={{
          minHeight: 'calc(100vh - 3.5rem)',
        }}
      >
        <div className="p-4">
          {isLoading &&
            [...Array(4)].map((_, index) => (
              <PlaylistCardShimmer key={index} />
            ))}
          {isSuccess && <Playlists playlists={data.data} />}
        </div>
        {isError && (
          <EmptyState
            title={'Gagal mengambil data'}
            description={'Video Repository tidak dapat diakses'}
          >
            <EmptyStateAction onClick={() => window.location.reload()}>
              Muat Ulang
            </EmptyStateAction>
          </EmptyState>
        )}
      </div>
    </>
  )
}

VideoRepositoryPage.layoutOpts = {
  className: 'pt-[94px]',
}

export default VideoRepositoryPage
